<template>
    <component v-bind:is="currentView"></component>
</template>

<script>
import Accounts from "./pages/Accounts.vue";
import Login from "./pages/Login.vue";
import Management from "./pages/Management.vue";

import Vue from "vue";
import Vuex from "vuex";
import VueHead from "vue-head";
import "./assets/custom.css";
import "./assets/jquery-ui.min.css";
import "./assets/bootstrap4.6.min.css";
import "./assets/fa/css/all.min.css";
import "./assets/popper.min.js"
import "./assets/jquery-3.3.1.slim.min.js"


Vue.use(Vuex);
Vue.use(VueHead);

const api_url = process.env.VUE_APP_ROOT_API;


const routes = {
    "/": Accounts,
    "/static/": Accounts,
    "/login": Login,
    "/static/login": Login,
    "/management": Management,
    "/static/management": Management,
};

const NotFound = {template: "<p>Page not found</p>"};

window.$ = require("jquery");
window.JQuery = require("jquery");
export default {
    name: "app",
    data() {
        return {
            currentRoute: window.location.pathname
        };
    },
    computed: {
        currentView() {
            return routes[this.currentRoute] || NotFound;
        }
    },
    components: {
        Accounts
    },
    head: {
        title: {
            inner: "Kassenbuch AStA FH Aachen"
        },
        meta: [
            {
                name: "viewport",
                content: "width=device-width, initial-scale=1, shrink-to-fit=no"
            }
        ],
        link: [
            {
                rel: "stylesheet",
                href:
                    "https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css",
                integrity:
                    "sha384-WskhaSGFgHYWDcbwN70/dfYBj47jz9qbsMId/iRN3ewGhXQFZCSftd1LZCfmhktB",
                crossorigin: "anonymous"
            },
            {
                rel: "stylesheet",
                href:
                    "/extra/fa/css/all.min.css",
                crossorigin: "anonymous"
            }
        ],
        script: [
            {
                t: "text/javascript",
                i: "FontAwesomeConfig = { autoReplaceSvg: 'true' }"
            },
            {
                t: "text/javascript",
                src: "https://code.jquery.com/jquery-3.3.1.slim.min.js",
                integrity:
                    "sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo",
                crossorigin: "anonymous"
                //body: true
            },
            {
                t: "text/javascript",
                src:
                    "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js",
                integrity:
                    "sha384-ZMP7rVo3mIykV+2+9J3UJ46jBk0WLaUAdn689aCwoqbBJiSnjAK/l8WvCWPIPm49",
                crossorigin: "anonymous",
                body: true
            },
            {
                t: "text/javascript",
                src:
                    "https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js",
                integrity:
                    "sha384-smHYKdLADwkXOn1EmN1qk/HfnUcbVRZyYmZ4qpPea6sjB/pTJ0euyQp0Mk8ck+5T",
                crossorigin: "anonymous",
                body: true
            }
        ]
    }
};
</script>

<style>
#app {
    min-height: 100%;
}
</style>
